import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "Your user account is almost setup!", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Please enter your desired password:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_password_input = _resolveComponent("password-input")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_toolbar_title, { class: "text-center" }, {
            default: _withCtx(() => [
              _createTextVNode(" Accept Invitation ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_separator),
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.accept && _ctx.accept(...args)), ["prevent"]))
      }, [
        _createVNode(_component_q_card_section, null, {
          default: _withCtx(() => [
            _hoisted_1,
            _hoisted_2,
            _createVNode(_component_password_input, {
              label: "Password",
              modelValue: _ctx.password,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event)),
              outlined: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_q_card_actions, { align: "center" }, {
          default: _withCtx(() => [
            _createVNode(_component_async_btn, {
              type: "submit",
              label: "Continue",
              task: _ctx.task,
              color: "primary",
              class: "full-width"
            }, null, 8, ["task"])
          ]),
          _: 1
        })
      ], 32)
    ]),
    _: 1
  }))
}